export default __webpack_public_path__ + "images/f0580a590a21316990dd4cf3c3944e41.jpg";